/**
 * Reduce an unknown thrown value to a user-safe display string. The platform
 * api client throws an error carrying a non-sensitive `message`; anything else
 * collapses to a generic line so we never surface a raw stack or `[object …]`.
 */
export function toErrorMessage(err: unknown): string {
  if (err instanceof Error && err.message) {
    return err.message;
  }
  return 'Something went wrong. Please try again.';
}

/**
 * Structural 404 probe. The platform api client throws an error object carrying
 * a numeric `status`; we detect "not found" without coupling to a concrete
 * error class so the seam stays decoupled from the api module's internals.
 */
export function isNotFound(err: unknown): boolean {
  return (
    typeof err === 'object' &&
    err !== null &&
    'status' in err &&
    (err as { status?: unknown }).status === 404
  );
}
